import { useQuery } from "convex/react";
import { useState, useEffect } from "react";

const TIMEOUT_MS = 6000;

/**
 * Wraps Convex useQuery with a timeout fallback.
 * When the Convex backend is unreachable, useQuery returns undefined forever.
 * This hook returns the provided fallback value after TIMEOUT_MS, allowing
 * pages to render empty states instead of infinite loading spinners.
 */
export function useStableQuery(
  queryFn: any,
  args: any,
  fallback: any = null,
) {
  const result = useQuery(queryFn, args);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (result !== undefined) {
      setTimedOut(false);
      return;
    }
    const timer = setTimeout(() => setTimedOut(true), TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [result]);

  if (result === undefined && timedOut) {
    return fallback;
  }
  return result;
}
